import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { injectFooterItems } from './provide-footer';

@Component({
    selector: 'sona-app-footer',
    imports: [RouterLink, TranslateModule],
    templateUrl: './app-footer.component.html',
    styleUrl: './app-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
    readonly footerItems = injectFooterItems();
}
